import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useDebounce } from '../../hooks/useDebounce'

const SearchForm = React.forwardRef(
  (
    { defaultQuery = '', performSearch, placeholder = '', children, onSubmit },
    ref
  ) => {
    const [query, setQuery] = useState(
      defaultQuery || new URLSearchParams(window.location.search).get('q') || ''
    );

    useEffect(() => {
      setQuery(defaultQuery);
    }, [defaultQuery]);

    const debouncedSearch = useDebounce(
      (value) => performSearch(value.length > 1 ? value : ''),
      500
    );

    const handleChange = ({ target: { value } }) => {
      setQuery(value);
      debouncedSearch(value);
    };

    const handleSubmit = (e) => {
      if (onSubmit) return onSubmit(e);
      e.preventDefault();
      performSearch(query);
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="has-feedback">
          <input
            ref={ref}
            type="text"
            name="q"
            value={query}
            placeholder={placeholder}
            onChange={handleChange}
            autoComplete="off"
            aria-label="Search"
          />
          {children || (
            <div className="icon">
              <i
                className="fa-solid fa-magnifying-glass"
                aria-hidden="true"
              ></i>
            </div>
          )}
        </div>
      </form>
    );
  }
);

SearchForm.propTypes = {
  defaultQuery: PropTypes.string,
  performSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
};

export default SearchForm;
